const environment = {
  development: {
    name: 'development',
    rootDomain: 'https://development.sayi.do',
    apiKey: 'AIzaSyCf5iA8P2dipwk0pmFgSnx0UZNtBTrswC0',
    authDomain: 'say-i-do-development-910e8.firebaseapp.com',
    databaseURL: 'https://say-i-do-development-910e8.firebaseio.com',
    projectId: 'say-i-do-development-910e8',
    storageBucket: 'say-i-do-development-910e8.appspot.com',
    messagingSenderId: '148605885427',
    stripePublishableKey: 'pk_test_JwNhhN05Ivvb8TXTQGZvpHjq',
    functionsEndpoint:
      'https://us-central1-say-i-do-development-910e8.cloudfunctions.net/',
    apiEndpoint: 'https://development.sayi.do/api',
    algoliaAppId: 'L14PYJGP1P',
    algoliaAPIKey: 'fab6bb6a5120a5f5c120be43c401779f',
    vendorIndex: 'development_vendors',
    mixpanelKey: '38c54c0335978e362c05c6ecd54dd804',
  },
  production: {
    name: 'production',
    rootDomain: 'https://sayi.do',
    apiKey: 'AIzaSyB4K_akYk86NlByFhobjOmutgjpk9o02Lg',
    authDomain: 'project-7552620506581992652.firebaseapp.com',
    databaseURL: 'https://project-7552620506581992652.firebaseio.com',
    projectId: 'project-7552620506581992652',
    storageBucket: 'project-7552620506581992652.appspot.com',
    messagingSenderId: '312981652567',
    stripePublishableKey: 'pk_live_Qm0xesTsLXTDmGj6jESQYuFh',
    functionsEndpoint:
      'https://us-central1-project-7552620506581992652.cloudfunctions.net/',
    apiEndpoint: 'https://sayi.do/api',
    algoliaAppId: 'L14PYJGP1P',
    algoliaAPIKey: 'fab6bb6a5120a5f5c120be43c401779f',
    vendorIndex: 'production_vendors',
    mixpanelKey: '74343b10554c9fabe6f503105a0f84f0',
  },
};

export default environment['production'];
